/**
 * 正常确认框
 * @param {*} param0
 */
export function normalConfirm({ title, content, onOk, ...otherOptions }) {
  this.$confirm({
    title: title,
    content: content,
    onOk: onOk,
    icon: h => {
      return h('a-icon', {
        props: {
          type: 'exclamation-circle',
          theme: 'filled',
        },
        style: {
          color: 'rgba(82, 196, 26, 1)',
        },
      });
    },
    centered: true,
    closable: true,
    maskClosable: true,
    ...otherOptions, // 其他自定义参数覆盖默认参数
  });
}

/**
 * 删除确认框
 * @param {*} param0
 */
export function deleteConfirm({ title, content, onOk, ...otherOptions }) {
  this.$confirm({
    title: title,
    content: content,
    onOk: onOk,
    icon: h => {
      return h('a-icon', {
        props: {
          type: 'exclamation-circle',
          theme: 'filled',
        },
        style: {
          color: 'red',
        },
      });
    },
    centered: true,
    closable: true,
    maskClosable: true,
    ...otherOptions, // 其他自定义参数覆盖默认参数
  });
}

/**
 * 禁用确认框
 * @param {*} param0
 */
export function disabledConfirm({ title, content, onOk, ...otherOptions }) {
  this.$confirm({
    title: title,
    content: content,
    onOk: onOk,
    icon: h => {
      return h('a-icon', {
        props: {
          type: 'exclamation-circle',
          theme: 'filled',
        },
        style: {
          color: '#FAAD14',
        },
      });
    },
    centered: true,
    closable: true,
    maskClosable: true,
    ...otherOptions, // 其他自定义参数覆盖默认参数
  });
}
